import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Product } from '../model/Product.model';
import { Observable } from 'rxjs';
import { URL_API } from './url.api';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  constructor(
    private http: HttpClient
  ) { }

  findById(product: Product): Observable<Product> {
    return this.http.get<Product>(`${URL_API}/products/${product.id}`);
  }

  save(product: Product): Observable<any> {
    return this.http.post<any>(`${URL_API}/products`, product);
  }

  update(product: Product): Observable<any> {
    return this.http.put<any>(`${URL_API}/products/${product.id}`, product);
  }

  delete(product: Product): Observable<any> {
    return this.http.delete<any>(`${URL_API}/products/${product.id}`);
  }

  findAll(): Observable<Array<Product>> {
    return this.http.get<Array<Product>>(`${URL_API}/products`);
  }

}
